import { render, staticRenderFns } from "./LiveStatus.vue?vue&type=template&id=5ca4b4d6&scoped=true&"
import script from "./LiveStatus.vue?vue&type=script&lang=js&"
export * from "./LiveStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca4b4d6",
  null
  
)

export default component.exports